<template>
  <main-layout />
</template>

<script>
import MainLayout from '@/components/layout/MainLayout.vue'
import { installViewportHeightSync } from '@/utils/viewportHeight.js'

export default {
  name: 'App',
  components: {
    MainLayout
  },
  mounted() {
    this.teardownViewportSync = installViewportHeightSync();

    // 🔥 仅在移动端禁用长按菜单（右键菜单）
    if (this.isMobileDevice()) {
      document.addEventListener('contextmenu', this.preventContextMenu);
    }
  },
  
  beforeUnmount() {
    if (this.teardownViewportSync) {
      this.teardownViewportSync();
    }

    // 清理长按菜单监听器（仅在移动端时）
    if (this.isMobileDevice()) {
      document.removeEventListener('contextmenu', this.preventContextMenu);
    }
  },
  
  data() {
    return {
      teardownViewportSync: null
    };
  },
  
  methods: {
    // 检测是否为移动端设备
    isMobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
             (window.innerWidth <= 768);
    },
    
    // 阻止长按菜单
    preventContextMenu(e) {
      e.preventDefault();
      return false;
    },
    
  }
}
</script>

<style lang="scss">
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  /* 禁止文字选中 */
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  /* 禁止拖拽 */
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

:root {
  /* 主题色 */
  --primary-color: #1088e9;
  --success-color: #52c41a;
  --warning-color: #faad14;
  --error-color: #f5222d;
  
  /* 文字颜色 */
  --text-color: #333333;
  --text-color-secondary: #666666;
  --text-color-light: #999999;
  
  /* 背景色 */
  --bg-color: #ffffff;
  --bg-color-light: #f7f7f7;
  --bg-color-dark: #f2f2f2;
  
  /* 边框颜色 */
  --border-color: #e8e8e8;
  
  /* 字体 */
  --font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
}

html, body {
  font-family: var(--font-family);
  font-size: 16px;
  color: var(--text-color);
  background-color: var(--bg-color-light);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  color: var(--primary-color);
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover {
  color: #40a9ff;
}

ul, ol {
  list-style: none;
}

img {
  max-width: 100%;
  height: auto;
}

/* 确保所有元素都禁止文字选中 */
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center, dl, dt, dd, ol, ul, li,
fieldset, form, label, legend, table, caption,
tbody, tfoot, thead, tr, th, td, article, aside,
canvas, details, embed, figure, figcaption, footer,
header, hgroup, menu, nav, output, ruby, section,
summary, time, mark, audio, video {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

/* 禁止长按菜单和右键菜单 */
* {
  -webkit-touch-callout: none;      /* iOS Safari 长按菜单 */
  -webkit-tap-highlight-color: transparent;  /* 点击高亮 */
}

html, body {
  /* 禁止长按弹出菜单 */
  -webkit-touch-callout: none;
  touch-action: manipulation;  /* 禁止双击缩放，优化触摸体验 */
}

/* 确保输入框等表单元素仍然可以选择文字（如果需要的话） */
input, textarea, [contenteditable] {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

/* 后台管理页允许选中/复制文本（日志编号、表格内容等） */
html.admin-selectable,
html.admin-selectable body,
html.admin-selectable *,
html.admin-selectable *::before,
html.admin-selectable *::after {
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: text !important;
  -webkit-touch-callout: default !important;
}

/*
 * iOS Safari：输入框 font-size < 16px 时聚焦会自动放大页面且失焦不恢复。
 * 仅针对 iOS WebKit，不影响桌面端 14px 等既有样式。
 */
@supports (-webkit-touch-callout: none) {
  input,
  textarea,
  select,
  .ant-input,
  .ant-input-affix-wrapper input,
  .ant-input-number-input,
  .ant-select-selection-search-input,
  .ant-picker-input > input {
    font-size: 16px !important;
  }

  /*
   * iOS Safari：列表项嵌套 backdrop-filter 会渲染成暗灰色。
   * 全局兜底，确保筛选/广场搜索结果与安卓端一致的半透明白色高亮。
   */
  .filter-result .music-item.active,
  .music-list-container .music-item.active,
  .online-song-item.active,
  .singer-song-item.active {
    -webkit-backdrop-filter: none !important;
    backdrop-filter: none !important;
    background-color: rgba(255, 255, 255, 0.12) !important;
  }

  .online-song-item.active,
  .singer-song-item.active {
    border-color: rgba(255, 255, 255, 0.18) !important;
    box-shadow: none !important;
  }
}
</style>

